import {
  isLoadingProjectSearchListSelector,
  projectsByIdsSelector,
} from 'store/state/domainData/selectors';
import {
  makeMapStateToPropsFactory,
  PoiGetter,
} from 'components/cards/listing/makeMapStateToPropsFactory';
import { State } from 'store/state';
import { IBulletin, IProject, PoiId, ResolutionPreference } from 'utils/entities';
import { UniversalCardProps } from 'components/cards/listing/UniversalCard/UniversalCard';
import UniversalCard from 'components/cards/listing/UniversalCard';
import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import Carousel from 'ds/components/carousels/carousel-projects';
import { CenteredCarouselControls } from 'ds/components/carousels/styled';
import { CardType } from 'components/cards/types';
import ContactButton from './ContactButton';
import { ContactAgentModalSource } from 'store/state/app';
import { ItemWrapper, ItemWrapperWithNavigation, StyledLink, Wrapper } from './styled';
import { projectsSelector } from './selectors';
import { Route } from 'config/routes';

interface ProjectCarouselProps {
  projectsList: Array<IBulletin | IProject>;
  isLoading: boolean;
  source: ContactAgentModalSource;
  carouselBgColor?: string;
  hideArrows?: boolean;
  allowNavigation?: boolean;
  navigationSource?: string;
}

const poiByIdsSelector: PoiGetter = (state: State, poiId: PoiId) => projectsByIdsSelector(state)[poiId];

const makeMapStateToProps = makeMapStateToPropsFactory(poiByIdsSelector);

const SpecificUniversalCard = (props: UniversalCardProps) => {
  let enhancedProps: UniversalCardProps = {
    ...props,
    hideLogoPreview: true,
    isMinHeight: true,
  };
  if (enhancedProps.cardType === CardType.Bulletin || enhancedProps.cardType === CardType.CommercialBulletin) {
    enhancedProps = {
      ...enhancedProps,
      resolutionPreferences: ResolutionPreference.Neighborhood,
    };
  }
  return <UniversalCard {...enhancedProps} />;
};

const ConnectedUniversalCard = connect(makeMapStateToProps)(SpecificUniversalCard);


export const ProjectCarousel: React.FC<ProjectCarouselProps> = props => {
  const { projectsList, isLoading, source, carouselBgColor, hideArrows, allowNavigation, navigationSource } = props;
  const [ projects, setProjects ] = useState(projectsList);

  useEffect(() => {
    setProjects(projectsList);
  }, [ isLoading ]);
  if (!projects) return null;

  const hasArrows = projects.length > 2 && !hideArrows;

  const list = projects.map(({ id, type }) => {
    if (allowNavigation) {
      return (
        <ItemWrapperWithNavigation key={id}>
          <StyledLink
            routeName={Route.ProjectPage}
            routeParams={{ id, tracking_event_source: navigationSource }}
            target="_blank"
          >
            <ConnectedUniversalCard id={id} showAddToFavourites={false} onlyOneImageShouldBeDisplayed />
          </StyledLink>
          <ContactButton id={id} source={source} />
        </ItemWrapperWithNavigation>
      );
    }

    return (
      <ItemWrapper key={id}>
        <ConnectedUniversalCard id={id} showAddToFavourites={false} onlyOneImageShouldBeDisplayed />
        <ContactButton id={id} source={source} />
      </ItemWrapper>
    );
  });

  return (
    <Wrapper>
      <CenteredCarouselControls>
        <Carousel
          isLoading={isLoading}
          hasArrows={hasArrows}
          arrowsGradientBgColor={carouselBgColor}
        >
          {list}
        </Carousel>
      </CenteredCarouselControls>
    </Wrapper>
  );
};

const mapStateToProps = (state: State) => ({
  projectsList: projectsSelector(state),
  isLoading: isLoadingProjectSearchListSelector(state),
});


export default connect(mapStateToProps)(ProjectCarousel);
